import { Box, CircularProgress, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useEffect, useRef } from "react"
import { uniqueId } from "library/database/split-id.mjs"
import { RegisterTypeProgress } from "library/server-event-definitions/shared-events.mjs"
import { getProcessedText } from "routes/asset-register/plugins/asset-mapping/plugins/progress-card/timing/progress-card-timing"
import { getActiveProcessingState } from "routes/asset-register/plugins/asset-mapping/plugins/progress-card/use-progress-card"

export function ProcessingSnackbarContent({ registerId, registerName, onViewProgress }) {
    const assetCountEl = useRef(null)
    const assetCountText = useRef("")

    useEffect(subscribeToProgress, [registerId])

    return (
        <Stack direction="row" spacing={2} alignItems="center" data-cy="processing-snackbar">
            <CircularProgress size={20} color="inherit" />
            <Box>
                <Typography variant="body2" fontWeight={500}>
                    {getSnackbarTitle(registerName)}
                </Typography>
                <Typography ref={assetCountEl} variant="caption" sx={{ opacity: 0.8 }}>
                    {assetCountText.current}
                </Typography>
            </Box>
            <Tooltip title="View Progress">
                <IconButton
                    size="small"
                    onClick={onViewProgress}
                    sx={{ color: "primary.main" }}
                    data-cy="view-progress-link"
                >
                    <Iconify icon="mdi:eye-outline" width={20} height={20} />
                </IconButton>
            </Tooltip>
        </Stack>
    )

    function subscribeToProgress() {
        const registerKey = uniqueId(registerId)
        getCurrentState()
        return RegisterTypeProgress.handle(handleProgress)

        function getCurrentState() {
            const currentProgressState = getActiveProcessingState(registerId)
            if (currentProgressState) updateText(getProcessedText(currentProgressState) ?? "Calculating...")
        }

        function handleProgress(eventRegisterId, lastBlockSize, remaining, total) {
            if (uniqueId(eventRegisterId) !== registerKey) return
            updateText(getProcessedText({ total, remaining }) ?? "")
        }

        function updateText(text) {
            assetCountText.current = text
            if (assetCountEl.current) assetCountEl.current.textContent = text
        }
    }
}

function getSnackbarTitle(registerName) {
    if (!registerName) {
        return "Processing in Progress"
    }

    return `Processing ${registerName}`
}
